import { ListItemButton, Tooltip } from '@mui/material';
import { gridRowSelectionIdsSelector, useGridApiContext, useGridSelector } from '@mui/x-data-grid-pro';
import InfoIcon from '@mui/icons-material/InfoTwoTone';
import { PutLegRequest, batchLegRequest } from '@api/Trinium/Endpoints/Leg';

import styles from '../../RenderCell.module.css';

/**
 * Run a Trace on the selected Container
 */
export default function TraceNowAction() {
	const gridApiRef = useGridApiContext();
	const selectedRowIds = useGridSelector(gridApiRef, gridRowSelectionIdsSelector);

	if (selectedRowIds.size === 0) {
		return <></>;
	}

	const handleBtnClick = () => {
		const requests: Omit<PutLegRequest, 'terminalNumber'>[] = [];
		selectedRowIds.forEach((_, key) =>
			requests.push({
				id: Number(key),
				actionType: {
					action: 'runTrace'
				}
			})
		);

		void batchLegRequest(requests);
	};

	return (
		<ListItemButton onClick={handleBtnClick}>
			<div className={styles['action-ico']}>
				<span>Trace Container Now</span>
				<Tooltip
					title='Trace is only run on imports that are in NA (not available) status.'
					placement='right'
				>
					<InfoIcon fontSize='small' />
				</Tooltip>
			</div>
		</ListItemButton>
	);
}
